import React, { useMemo, useState } from 'react'
import { Form } from 'react-bootstrap'
import { Card } from 'react-bootstrap-v5'
import DataTable from './DataTable'
import { numberFormat } from '../helpers/GlobalHelper'

const today = () => {
	const now = new Date()
	const month = String(now.getMonth() + 1).padStart(2, '0')
	const day = String(now.getDate()).padStart(2, '0')
	return `${now.getFullYear()}-${month}-${day}`
}

const ProductListReport: React.FC = () => {
	const [selectedDate, setSelectedDate] = useState(today())
	const [appliedDate, setAppliedDate] = useState(today())

	const columns = [
		{ value: 'idProducts', title: 'ID', style: { textAlign: 'center' } },
		{ value: 'productName', title: 'Product Name', style: { textAlign: 'left' } },
		{ value: 'categoryName', title: 'Category', style: { textAlign: 'left' } },
		{ value: 'packing', title: 'Packing', style: { textAlign: 'left' } },
		{ value: 'size', title: 'Size', style: { textAlign: 'right' } },
		{ value: 'unit', title: 'Unit', style: { textAlign: 'left' } },
		{
			value: 'salePerUnit',
			title: 'Sale Per Unit',
			style: { textAlign: 'right' },
			hasHtmlComponent: true,
			htmlComponent: (row: any) => <>{numberFormat(row.salePerUnit)}</>,
		},
		{
			value: 'productionCost',
			title: 'Production Cost',
			style: { textAlign: 'right' },
			hasHtmlComponent: true,
			htmlComponent: (row: any) => <>{row.productionCost === null || row.productionCost === '' ? '' : numberFormat(row.productionCost)}</>,
		},
	]

	const filters = {
		idProducts: { filterType: 'like', filterValue: '' },
		productName: { filterType: 'like', filterValue: '' },
		categoryName: { filterType: 'like', filterValue: '' },
		packing: { filterType: 'like', filterValue: '' },
		size: { filterType: 'like', filterValue: '' },
		unit: { filterType: 'like', filterValue: '' },
		salePerUnit: { filterType: 'like', filterValue: '' },
		productionCost: { filterType: 'like', filterValue: '' },
	}

	const additionalPostData = useMemo(() => ({
		productionCostDate: appliedDate,
	}), [appliedDate])

	return (
		<>
			<Card className="mb-4">
				<Card.Body>
					<div className="row">
						<div className="col-md-3">
							<Form.Group className="mb-0">
								<Form.Label>Production Cost Date</Form.Label>
								<Form.Control
									type="date"
									name="productionCostDate"
									max={today()}
									value={selectedDate}
									onChange={(event) => setSelectedDate(event.target.value || today())}
								/>
							</Form.Group>
						</div>
						<div className="col-md-2 d-flex align-items-end">
							<button
								type="button"
								className="btn btn-primary btn-sm"
								onClick={() => setAppliedDate(selectedDate || today())}
							>
								Show
							</button>
						</div>
					</div>
				</Card.Body>
			</Card>
			<DataTable
				url={process.env.REACT_APP_API_URL + 'reports/product-list'}
				columns={columns}
				filters={filters}
				additionalPostData={additionalPostData}
				defaultSortedColumn="idProducts"
				defaultSortOrder="ASC"
			/>
		</>
	)
}

export default ProductListReport
